import { isToday, isTomorrow, isYesterday } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { formatDateWithWeekdayLong } from '../../lib/date-helpers.ts';
import { useResolvedLocale } from '../../lib/hooks/locale.ts';

type RelativeDateTextProps = {
    date: Date;
};

export function RelativeDateText({ date }: RelativeDateTextProps) {
    const { t } = useTranslation();
    const locale = useResolvedLocale();

    // Get relative date text
    let relativeDate = null;
    if (isToday(date)) {
        relativeDate = t('today');
    } else if (isYesterday(date)) {
        relativeDate = t('yesterday');
    } else if (isTomorrow(date)) {
        relativeDate = t('tomorrow');
    }

    // Format date using Intl (short date format)
    const formattedDate = formatDateWithWeekdayLong(date, locale);

    return (
        <span>
            {!!relativeDate && `${relativeDate}, `}
            <span>{formattedDate}</span>
        </span>
    );
}
